// English translations, keyed by the Vietnamese source string.
// Missing keys fall back to Vietnamese, so pages can be translated gradually.
const en: Record<string, string> = {
  // layout
  "Trang chủ": "Home",
  "Thuê máy": "Rent",
  "Thuê máy tính": "Rent a PC",
  "Thuê Máy Tính": "Rent a PC",
  "Cloud Gaming - Render": "Cloud Gaming - Render",
  "Thuê VPS": "Rent a VPS",
  "Thuê linh kiện mang về": "Rent parts",
  "Đơn hàng": "Orders",
  "Quản lý đơn hàng": "Orders",
  "Quản lý đơn hàng Cloud": "Cloud orders",
  "Quản lý đơn hàng VPS": "VPS orders",
  "Hợp Đồng Thuê Máy": "Rental contract",
  "Tài khoản": "Account",
  "Nạp tiền": "Top up",
  "Xác minh danh tính": "Identity verification",
  "Xác minh Số Điện Thoại": "Verify phone number",
  "Giới thiệu bạn bè": "Refer friends",
  "Quản lý Log": "Logs",
  "Hỗ trợ": "Support",
  "Yêu Cầu Tải Game": "Game download request",
  "Hướng dẫn sử dụng": "User guide",
  "Số dư": "Balance",
  "Ngôn ngữ": "Language",
  "Giao diện": "Appearance",
  "Sáng": "Light",
  "Tối": "Dark",
  "Hệ thống": "System",
  "Đổi mật khẩu": "Change password",
  "Đăng xuất": "Sign out",
  "Mở menu": "Open menu",
  "Menu chính": "Main menu",
  // thuê máy tính
  "Bạn chưa thuê máy nào": "You haven't rented any machine yet",
  "Bỏ chọn": "Clear",
  "Chỉ hiện máy sẵn sàng": "Only show available",
  "Chọn cấu hình": "Select",
  "Dự kiến có máy": "Expected availability",
  "Gia hạn": "Extend",
  "Gia hạn thành công": "Extended successfully",
  "Giá cao → thấp": "Price high → low",
  "Giá thấp → cao": "Price low → high",
  "Hết máy": "Sold out",
  "Không có VGA": "No GPU",
  "Không có cấu hình nào khớp bộ lọc.": "No configuration matches the filters.",
  "Lịch sẵn sàng": "Availability",
  "Máy thuê / ID máy": "Machine / ID",
  "Máy vật lý": "Physical PC",
  "Máy đang thuê": "Rented machines",
  "Nạp thêm": "Top up",
  "Phổ biến": "Popular",
  "Sẵn sàng": "Available",
  "Số dư hiện tại": "Current balance",
  "Thao tác": "Actions",
  "Thông tin tạo máy": "New machine",
  "Thời gian": "Duration",
  "Tiếp tục": "Continue",
  "Trạng thái": "Status",
  "Tên máy": "Machine name",
  "Tìm theo tên, CPU, GPU…": "Search by name, CPU, GPU…",
  "Tạo máy ngay": "Create machine",
  "Tất cả": "All",
  "Vui lòng đăng nhập lại để sử dụng tính năng này": "Please sign in again to use this feature",
  "Xoá máy": "Delete machine",
  "cấu hình": "configurations",
  "giờ": "hours",
  "ngày": "days",
  "tháng": "months",
  "Có": "",
  "Đang chạy": "Running",
  "Đang tạo máy…": "Creating…",
  "Đã chọn": "Selected",
  "Đã sao chép": "Copied",
  "Đóng": "Close",
  "Sao chép ID máy": "Copy machine ID",
  "Sao chép mật khẩu": "Copy password",
  // cloud
  "Chọn loại máy, cấu hình và thời gian thuê. Máy sẽ được tạo ngay sau khi thanh toán.": "Pick a machine type, configuration and rental time. Your machine is created right after payment.",
  "Loại máy": "Machine type",
  "Cloud PC": "Cloud PC",
  "Nhập tên Image Cloud": "Cloud machine name",
  "Hạn sử dụng": "Valid for",
  "Thời gian sử dụng": "Usage time",
  "Tối đa": "Max",
  "phiên": "session",
  "Cloud đang thuê": "Rented Cloud machines",
  "Bạn chưa thuê Cloud nào": "You haven't rented any Cloud machine yet",
  "Hết hạn": "Expired",
  "Chưa có": "Not yet",
  "Thêm phần cứng": "Add hardware",
  "Sao chép địa chỉ remote": "Copy remote address",
  "Chưa yêu cầu thêm": "Not requested",
  "Đang chờ": "Pending",
  "Thành Công": "Approved",
  "Thất bại": "Rejected",
  "Sắp ra mắt": "Coming soon",
  "Cloud PC đang được xây dựng.": "Cloud PC is under construction.",
  "Chọn gói Cloud và đặt tên máy. Máy sẽ được tạo ngay sau khi thanh toán.": "Pick a Cloud plan and name your machine. It is created right after payment.",
  "Bộ lọc": "Filters",
  "Xoá lọc": "Clear",
  "Dòng GPU": "GPU",
  "Dung lượng RAM": "RAM",
  "Dung lượng ổ": "Disk",
  "tuỳ chọn": "optional",
  "Ví dụ: Máy treo game": "e.g. Idle game PC",
  "Hệ điều hành": "Operating system",
  "Thời gian thuê": "Rental time",
  "Theo giờ": "Hourly",
  "Theo ngày": "Daily",
  "Theo tháng": "Monthly",
  "Số": "Number of",
  "Thành tiền": "Total",
  "Bấm vào một thẻ máy đang sẵn sàng để bắt đầu.": "Click an available machine card to start.",
  "Tìm theo tên máy, ID, cấu hình…": "Search by name, ID, configuration…",
  "Không tìm thấy máy nào": "No machines found",
  "Chưa thuê": "Not rented",
  "Chờ tạo máy…": "Creating machine…",
  "Bắt Đầu Thuê": "Start renting",
  "Tạo pass mới": "New password",
  "Chat trực tuyến": "Live chat",
  "Mở hỗ trợ": "Open support",
  "Thu gọn hỗ trợ": "Close support",
  "Đã kết thúc": "Ended",
  "Tạo lại máy": "Recreate",
  "Đăng nhập": "Login",
  "Tạo lúc": "Created",
  "ID máy": "Machine ID",
  "Đang khởi tạo": "Starting",
  "Thông tin đăng nhập sẽ hiện khi máy tạo xong": "Login details appear once the machine is ready",
  "Máy đã kết thúc, thông tin đăng nhập đã thu hồi": "Machine ended, login details revoked",
  "Máy đang tạo, không thể xoá": "Machine is being created and can't be deleted",
  "Máy đang chạy, không thể xoá. Chỉ xoá được máy đã kết thúc.": "Running machines can't be deleted. Only ended machines can.",
  "Bấm để tạo lại máy với cấu hình này": "Click to recreate a machine with this configuration",
  "Đăng nhập / IP remote": "Login / remote IP",
  "Ẩn mật khẩu": "Hide password",
  "Hiện mật khẩu": "Show password",
  "Sao chép tài khoản": "Copy account",
  "Sao chép SSH port": "Copy SSH port",
  "Tìm theo tên máy, ID, IP…": "Search by name, ID, IP…",
  "Kết nối, gia hạn, đổi đường truyền, IP xoay. Máy đã kết thúc có thể tạo lại với cấu hình cũ.": "Connect, extend, switch line, rotate IP. Ended machines can be recreated with the same configuration.",
  "Máy đang được thuê ở đơn khác, không thể xoá": "This machine is rented in another order and can't be deleted",
  "Gia hạn máy": "Extend machine",
  "đang thuê": "rented for",
  "Gia hạn theo": "Extend by",
  "Thêm số": "Add",
  "Kết thúc hiện tại": "Current end",
  "Kết thúc sau gia hạn": "New end",
  "Thêm": "Added",
  "Tổng thời gian thuê": "Total rental time",
  "Số dư còn lại sau gia hạn": "Balance after extension",
  "Số dư không đủ, cần nạp thêm": "Insufficient balance, please top up",
  // cloud gaming
  "Không giới hạn": "Unlimited",
  "Còn máy": "Available",
  "gói vừa hết máy, vui lòng chọn gói khác": "this package just ran out of machines, please pick another",
  "Chọn gói": "Choose plan",
  "gói": "plans",
  "Chỉ hiện gói còn máy": "Only show available plans",
  "Hiện không có gói nào còn máy.": "No plans are available right now.",
  "mỗi giờ chơi": "per play hour",
  "Thông tin tạo Image": "New Image",
  "Tên Image": "Image name",
  "Nhập tên Image trước khi tạo.": "Enter an Image name first.",
  "Ví dụ: Valorant + OBS": "e.g. Valorant + OBS",
  "đến": "until",
  "tự tắt sau": "auto-off after",
  "Tôi hiểu gói không được hoàn tiền sau khi tạo và đồng ý": "I understand plans are non-refundable and agree to the",
  "Đang tạo…": "Creating…",
  "Tạo Image": "Create Image",
  "Image Cloud của tôi": "My Cloud Images",
  "Bật, tắt, kết nối, gia hạn và theo dõi giờ chơi còn lại của từng Cloud.": "Start, stop, connect, extend and track remaining play time for each Cloud.",
  "Tìm theo tên Image…": "Search by Image name…",
  "Không tìm thấy Image nào": "No Images found",
  "Bạn chưa có Image Cloud nào": "You don't have any Cloud Image yet",
  "Chọn một gói ở trên, Image sẽ hiện tại đây ngay sau khi tạo.": "Pick a plan above; your Image appears here once it's created.",
  "Đang tạo...": "Creating...",
  "Đã tắt": "Stopped",
  "Hết giờ chơi": "Out of play time",
  "Đã chơi": "Played",
  "Còn": "Left",
  "còn": "left",
  "Mỗi session": "Per session",
  "Đang cấp thông tin đăng nhập…": "Issuing login details…",
  "Đang tính giờ từ": "Billing since",
  "lần này đã dùng": "used this session",
  "Tự tắt lúc": "Auto-off at",
  "Không giới hạn thời gian session.": "No session time limit.",
  "Đang thực hiện (Vui lòng chờ trong giây lát)": "Working (please wait a moment)",
  "Đã tới hạn sử dụng nên đơn hàng kết thúc. Gia hạn để dùng tiếp Cloud này.": "This order has expired. Extend to keep using this Cloud.",
  "Đã dùng hết": "Used all",
  "giờ chơi. Gia hạn để chơi tiếp, dữ liệu trong Cloud vẫn được giữ.": "play hours. Extend to keep playing; your Cloud data is kept.",
  "giờ chơi nhưng chỉ còn": "of play time left but only",
  "giờ tới hạn sử dụng. Giờ chưa dùng sẽ mất khi hết hạn.": "hours until expiry. Unused hours are lost when it expires.",
  "Bản sao lưu gần nhất": "Latest backup",
  "Bật máy": "Start",
  "Thao tác khác": "More actions",
  "Tắt máy": "Shut down",
  "Khởi động lại": "Restart",
  "Mua gói giờ chơi trên máy chủ có GPU. Mọi thứ bạn cài đặt được lưu trong Image Cloud riêng, lần sau mở lại vẫn còn nguyên.": "Buy play-time plans on GPU servers. Everything you install stays in your own Cloud Image for next time.",
  "Image của tôi": "My Images",
  "Thẻ": "Cards",
  "So sánh": "Compare",
  "Giá": "Price",
  "Giá mỗi giờ chơi": "Price per play hour",
  "Giờ chơi": "Play time",
  "Mỗi session (tự tắt sau)": "Per session (auto-off after)",
  "Tình trạng": "Availability",
  "Hàng chờ": "Queue",
  "Đang chờ máy": "In queue",
  "Đang khởi động": "Starting",
  "Đang khởi động lại": "Restarting",
  "Đang khởi động…": "Starting…",
  "Đang bật máy và nạp dữ liệu…": "Starting the machine and loading your data…",
  "Đang khởi động lại máy…": "Restarting the machine…",
  "Đang tắt": "Shutting down",
  "Đang tắt…": "Shutting down…",
  "Đang tắt máy và lưu dữ liệu…": "Shutting down and saving your data…",
  "Đang sao lưu": "Backing up",
  "Đang sao lưu…": "Backing up…",
  "Đang sao lưu máy, vui lòng chờ trong giây lát…": "Backing up the machine, please wait a moment…",
  "Đang khôi phục": "Restoring",
  "Đang khôi phục…": "Restoring…",
  "Đang khôi phục máy về bản sao lưu…": "Restoring the machine from the backup…",
  "Đang xử lý…": "Working…",
  "Đang thực hiện, vui lòng chờ trong giây lát…": "Working on it, please wait a moment…",
  "Đang tạo": "Creating",
  "Sao lưu": "Back up",
  "Khôi phục": "Restore",
  "thất bại": "failed",
  "Đang tạo Cloud, tạo xong sẽ hiện nút Bật máy.": "Creating the Cloud. The Turn on button appears when it’s ready.",
  "Máy bắt đầu tính giờ chơi ngay khi bật.": "Play time starts counting as soon as the machine is on.",
  "Máy sẽ tắt rồi bật lại, giờ chơi vẫn được tính trong lúc khởi động lại.": "The machine turns off and on again; play time keeps counting during the restart.",
  "Máy ngừng tính giờ và lưu dữ liệu. Sau khi tắt cần chờ 2 phút mới bật lại được.": "The clock stops and your data is saved. Wait 2 minutes before turning it on again.",
  "Máy đang chạy sẽ bị tắt.": "The running machine will be turned off.",
  "Dữ liệu trong Cloud và bản sao lưu sẽ mất, không thể khôi phục. Giờ chơi còn lại không được hoàn tiền.": "Everything in the Cloud and its backup is lost and can’t be recovered. Remaining play hours aren’t refunded.",
  "Đã xoá Cloud": "Deleted Cloud",
  "Tạo bản sao lưu toàn bộ máy ở thời điểm này.": "Create a full backup of the machine as it is now.",
  "Bản sao lưu cũ": "The previous backup",
  "sẽ được thay thế.": "will be replaced.",
  "Máy sẽ quay về bản sao lưu": "The machine goes back to the backup",
  "Mọi thay đổi sau thời điểm đó sẽ mất.": "Any changes after that point are lost.",
  "Rời hàng chờ": "Leave queue",
  "đã rời hàng chờ": "left the queue",
  "Máy đang đầy. Bạn ở vị trí": "Servers are full. You are number",
  "trong hàng chờ, máy sẽ tự bật khi tới lượt.": "in the queue; the machine turns on when it’s your turn.",
  "Dự kiến chờ khoảng": "Estimated wait",
  "Thời gian chờ": "Wait time",
  "Chưa xác định": "Unknown",
  "Sắp tới lượt.": "Almost your turn.",
  "Nhập tên máy": "Enter a machine name",
  "Nhập tên máy trước khi tạo.": "Enter a machine name before creating.",
  "tạm hết": "sold out",
  "Chọn hệ điều hành trước khi tạo.": "Choose an OS before creating.",
  "đang tạm hết máy, hãy chọn hệ điều hành khác.": "is sold out for now, please choose another OS.",
  "Vui lòng nhập tên máy": "Please enter a machine name",
  "Tất cả trạng thái": "All statuses",
  "Lọc theo trạng thái": "Filter by status",
  "Đang bật…": "Starting…",
  "Có hàng chờ": "Has queue",
  "Không hàng chờ": "No queue",
  "Tạm hết máy": "Temporarily full",
  "Hết máy, chờ có máy mới tạo được gói": "Full, wait for a free machine to create this package",
  "đã gồm VAT": "VAT included",
  "Giá (đã gồm VAT)": "Price (VAT included)",
  "Hàng chờ là gì?": "What is the queue?",
  "Gói có hàng chờ dùng chung máy chủ: khi bấm Bật máy mà máy đang đầy, bạn xếp hàng và máy tự bật khi tới lượt. Gói không hàng chờ luôn bật được ngay.": "Packages with a queue share servers: if the server is full when you press Start, you wait in line and the machine starts on your turn. Packages without a queue always start right away.",
  "Giờ chơi và hạn sử dụng khác nhau thế nào?": "What's the difference between play time and validity?",
  "Giờ chơi là số giờ bạn được dùng máy, dùng hết thì phải gia hạn. Hạn sử dụng là ngày cuối cùng được dùng số giờ đó: tới hạn mà vẫn còn giờ thì đơn hàng cũng kết thúc.": "Play time is how many hours you can use the machine; extend when it runs out. Validity is the last day you can use those hours: when it expires the order ends even if hours are left.",
  "Session là gì?": "What is a session?",
  "Mỗi lần bấm Bật máy là một session và bắt đầu tính giờ. Nếu không tắt, tới hết thời gian session máy tự tắt và lưu dữ liệu, muốn chơi tiếp bạn bấm Bật máy lại.": "Each Start begins a billed session. If you don't stop it, the machine shuts down and saves at the end of the session; press Start again to continue.",
  "Dữ liệu được lưu thế nào?": "How is my data kept?",
  "Game và phần mềm bạn cài nằm trong Image Cloud, được lưu sau mỗi session cho tới khi Image hết hạn.": "Games and software you install live in your Cloud Image and are saved after each session until the Image expires.",
  "Đặt tên Image": "Name your Image",
  "Để nhận ra Image trong danh sách.": "So you can spot it in the list.",
  "Trừ tiền từ số dư, dùng được ngay.": "Paid from your balance, ready right away.",
  "Bấm vào một gói ở bên trái.": "Click a plan on the left.",
  "Cần gia hạn": "Needs renewal",
  "Sao lưu máy (Backup VM)": "Back up (Backup VM)",
  "Khôi phục máy (Restore VM)": "Restore (Restore VM)",
  "Xoá Cloud": "Delete Cloud",
  "Đặt tên Image và thanh toán": "Name the Image and pay",
  "Image được tạo ngay, trừ tiền từ số dư.": "The Image is created right away and paid from your balance.",
  "Bấm Bật máy để bắt đầu tính giờ": "Press Start to begin billing",
  "Tắt máy là ngừng tính giờ. Hết giờ chơi hoặc tới hạn sử dụng thì gia hạn.": "Shutting down stops billing. Extend when play time or validity runs out.",
  "So sánh giờ chơi, thời gian mỗi session và hàng chờ.": "Compare play time, session length and queue.",
  "Đợt": "Slot",
  "Chưa có lịch dự kiến.": "No expected schedule yet.",
  "Lưu ý: time ready có thể lệch từ 1-5 phút": "Note: ready times may vary by 1-5 minutes",
  "Đổi đường truyền": "Switch line",
  "IP xoay": "Rotating IP",
  "Reset máy": "Reset machine",
  "PCRender Tunnel": "PCRender Tunnel",
  // Thuê VPS
  "VPS chưa có IP Remote": "This VPS has no remote IP yet",
  "Hệ thống đang cấp VPS. Khi xong, trạng thái chuyển sang Đang thuê và thông tin đăng nhập hiện ở đây.":
    "The system is setting up your VPS. When done, it switches to Active and the login details appear here.",
  "Dùng được khi VPS đã sẵn sàng": "Available once the VPS is ready",
  "Bạn chưa thuê VPS nào": "You haven't rented any VPS yet",
  "Bắt đầu": "Start",
  "Bắt đầu thuê": "Start renting",
  "Chưa có gói VPS nào.": "No VPS plans yet.",
  "Chọn hệ điều hành": "Choose an OS",
  "Chọn một gói ở trên, VPS sẽ hiện tại đây ngay sau khi đặt.": "Pick a plan above; your VPS shows up here right after ordering.",
  "Có GPU": "With GPU",
  "Không GPU": "No GPU",
  "Cần chọn hệ điều hành": "Please choose an OS",
  "Gia hạn VPS": "Extend VPS",
  "Gói này hiện không còn cung cấp": "This plan is no longer available",
  "ID VPS": "VPS ID",
  "Không": "None",
  "Không tìm thấy VPS nào": "No VPS found",
  "Kết thúc": "Ended",
  "Đang thuê": "Active",
  "Máy chủ": "Server",
  "Máy chủ ảo thuê theo tháng, có gói kèm GPU để chạy giả lập. Đặt xong, admin sẽ cấp VPS và thông tin đăng nhập.": "Monthly virtual servers, with GPU plans for emulators. After ordering, an admin sets up the VPS and its login details.",
  "Mạng": "Network",
  "Số tháng": "Months",
  "Số tháng gia hạn": "Months to add",
  "Theo dõi trạng thái, thông tin đăng nhập và gia hạn từng VPS.": "Track status and login details, and extend each VPS.",
  "Thông tin thuê VPS": "VPS order",
  "Thời gian thêm": "Added time",
  "Tìm theo tên cấu hình…": "Search by plan name…",
  "Tôi hiểu VPS không được hoàn tiền sau khi thuê, đã chọn đúng thời gian sử dụng và đồng ý": "I understand a VPS is non-refundable once rented, I chose the right duration, and I agree to the",
  "Tạo lại VPS": "Recreate VPS",
  "VPS của tôi": "My VPS",
  "VPS sẽ hết hạn sau": "This VPS expires in",
  "ngày. Gia hạn để không bị gián đoạn.": "days. Extend it to avoid interruption.",
  "VPS đã kết thúc, thông tin đăng nhập đã thu hồi": "VPS ended, login details revoked",
  "Đang chờ hệ thống cấp tài khoản, mật khẩu và IP": "Waiting for the system to provide the account, password and IP",
  "chiết khấu": "discount",
  "điều khoản sử dụng": "terms of service",
  "Chọn gói VPS": "Choose a VPS plan",
  "Chọn số tháng và hệ điều hành": "Choose months and OS",
  "Thuê theo tháng, trừ tiền từ số dư.": "Billed monthly from your balance.",
  "Chờ hệ thống cấp VPS": "Wait for the system to set it up",
  "Thông tin đăng nhập hiện trong VPS của tôi.": "Login details appear in My VPS.",
  "So sánh CPU, RAM, GPU và giá theo tháng.": "Compare CPU, RAM, GPU and monthly price.",
  "Thanh toán từ số dư, không hoàn tiền sau khi thuê.": "Paid from your balance, non-refundable once rented.",
  "Xong sẽ hiện tài khoản, mật khẩu, IP trong VPS của tôi.": "Then the account, password and IP appear in My VPS.",
  "Giá mỗi tháng": "Price per month",
  "Kết thúc dự kiến": "Expected end",
  "Thử từ khoá khác hoặc chọn bộ lọc \"Tất cả\".": "Try another keyword or the \"All\" filter.",
  "Sao chép ID VPS": "Copy VPS ID",
  "Vì sao VPS ở trạng thái Đang chờ?": "Why is my VPS pending?",
  "VPS đang được hệ thống khởi tạo và cập nhật. Khi xong, trạng thái chuyển sang Đang thuê và tài khoản, mật khẩu, IP hiện trong VPS của tôi.": "The system is setting up the VPS. When done, the account, password and IP appear in My VPS.",
  "Kết nối VPS thế nào?": "How do I connect?",
  "Dùng Remote Desktop hoặc SSH tới địa chỉ IP Remote/SSH bằng tài khoản và mật khẩu được cấp. PCRender Tunnel giúp bỏ qua NAT và giảm độ trễ.": "Use Remote Desktop or SSH to the Remote/SSH address with the provided account and password. PCRender Tunnel bypasses NAT and lowers latency.",
  // Thuê linh kiện mang về
  "Thuê CPU, VGA, RAM, SSD… về lắp vào máy của bạn. PCRENDER giao và nhận lại tận nơi.": "Rent a CPU, GPU, RAM, SSD… for your own PC. PCRENDER delivers and picks up at your door.",
  "Cách thức thuê": "How it works",
  "Điều khoản thuê": "Rental terms",
  "Cách thức thuê linh kiện": "How parts rental works",
  "Điều khoản thuê linh kiện": "Parts rental terms",
  "điều khoản thuê linh kiện": "the parts rental terms",
  "Loại linh kiện": "Part type",
  "sản phẩm": "products",
  "Bo mạch chủ": "Motherboard",
  "Bộ vi xử lý": "Processor",
  "Card đồ hoạ": "Graphics card",
  "Bộ nhớ trong": "Memory",
  "Ổ cứng SSD": "SSD storage",
  "Nguồn máy": "Power supply",
  "Combo linh kiện": "Parts combo",
  "Máy đồng bộ": "Prebuilt PC",
  "PC nguyên case": "Complete PC",
  "Tìm linh kiện, ví dụ: 4090, DDR5, Z790…": "Search parts, e.g. 4090, DDR5, Z790…",
  "Chỉ hiện còn hàng": "In stock only",
  "Sắp xếp": "Sort",
  "Còn hàng trước": "In stock first",
  "Giá thấp đến cao": "Price: low to high",
  "Giá cao đến thấp": "Price: high to low",
  "Linh kiện cho thuê": "Parts for rent",
  "Không có linh kiện phù hợp": "No matching parts",
  "Thử từ khoá khác, chọn loại khác hoặc bỏ lọc \"Chỉ hiện còn hàng\".": "Try another keyword, another type, or turn off \"In stock only\".",
  "Cọc": "Deposit",
  "hoàn lại khi trả": "refunded on return",
  "Khu vực hỗ trợ": "Service area",
  "Còn hàng": "In stock",
  "Hết hàng": "Out of stock",
  "Thuê": "Rent",
  "Yêu cầu đã gửi": "Sent requests",
  "PCRENDER xem yêu cầu và gọi lại cho bạn để xác nhận, giao hàng và nhận cọc.": "PCRENDER reviews your request and calls you to confirm, deliver and take the deposit.",
  "Chưa gửi yêu cầu nào": "No requests yet",
  "Chọn linh kiện ở trên và bấm Thuê để gửi yêu cầu.": "Pick a part above and press Rent to send a request.",
  "Linh kiện": "Part",
  "Mã yêu cầu": "Request ID",
  "Sao chép mã yêu cầu": "Copy request ID",
  "Gửi lại": "Send again",
  "Mới gửi": "Sent",
  "Đã duyệt": "Approved",
  "Đang giao hàng": "Shipping",
  "Đã nhận hàng": "Received",
  "Đã trả, hoàn cọc": "Returned, deposit refunded",
  "Đã huỷ": "Cancelled",
  "Gửi yêu cầu thuê": "Send rental request",
  "Đã gửi yêu cầu thuê": "Rental request sent",
  "PCRENDER sẽ gọi lại số": "PCRENDER will call",
  "để xác nhận và hẹn giờ giao hàng.": "to confirm and schedule delivery.",
  "Xem yêu cầu của tôi": "See my requests",
  "Hiện chỉ giao và nhận lại linh kiện tại": "Delivery and pickup are currently only available in",
  "Thông tin thuê": "Rental details",
  "Hình thức thuê": "Rental type",
  "Ngày nhận hàng": "Delivery date",
  "trả ngày": "return on",
  "Số lượng": "Quantity",
  "Người nhận": "Recipient",
  "Dùng thông tin tài khoản": "Use account details",
  "Họ tên": "Full name",
  "Số điện thoại": "Phone number",
  "Địa điểm thuê": "Rental location",
  "Địa chỉ nhận hàng": "Delivery address",
  "Ghi chú": "Note",
  "Nhập họ và tên": "Enter your full name",
  "Số nhà, tên đường, phường/xã…": "House number, street, ward…",
  "Nhận xác nhận qua email": "Get confirmation by email",
  "Giờ nhận hàng, yêu cầu khác…": "Delivery time, other requests…",
  "Tạm tính": "Estimate",
  "Đơn giá": "Unit price",
  "Nhận → trả": "Delivery → return",
  "Tiền thuê": "Rental fee",
  "Tiền cọc (hoàn lại)": "Deposit (refundable)",
  "Chưa trừ tiền khi gửi yêu cầu. Tiền thuê và cọc thanh toán khi nhận hàng.": "Nothing is charged when you send the request. Rent and deposit are paid on delivery.",
  "Tiền cọc sẽ được hoàn lại sau khi trả sản phẩm và không phát sinh hư hỏng.": "The deposit is refunded after you return the item undamaged.",
  "Giá thuê đã bao gồm VAT (nếu có).": "Prices include VAT (if any).",
  "Tôi đồng ý": "I agree to",
  "Yêu cầu của bạn sẽ được PCRENDER xác nhận trong thời gian sớm nhất.": "PCRENDER will confirm your request as soon as possible.",
  "Chọn ngày nhận hàng": "Choose a delivery date",
  "Chọn địa điểm thuê": "Choose a rental location",
  "Vui lòng nhập họ tên": "Please enter your full name",
  "Vui lòng nhập số điện thoại": "Please enter your phone number",
  "Số điện thoại chưa đúng, ví dụ 0901234567": "Invalid phone number, e.g. 0901234567",
  "Vui lòng nhập địa chỉ nhận hàng": "Please enter a delivery address",
  "Email chưa đúng định dạng": "Invalid email address",
  "Chọn linh kiện và gửi yêu cầu": "Pick parts and send a request",
  "Chọn thời gian thuê, số lượng và địa chỉ nhận hàng. Chưa trừ tiền ở bước này.": "Choose the duration, quantity and delivery address. Nothing is charged yet.",
  "PCRENDER gọi lại cho bạn": "PCRENDER calls you",
  "Xác nhận yêu cầu và hẹn giờ giao hàng qua điện thoại.": "We confirm the request and schedule delivery by phone.",
  "Nhận hàng, thanh toán và đặt cọc": "Receive, pay and leave a deposit",
  "Kiểm tra linh kiện trước khi thanh toán tiền thuê và tiền cọc.": "Check the parts before paying the rent and deposit.",
  "Trả linh kiện, nhận lại cọc": "Return the parts, get your deposit back",
  "PCRENDER đến nhận lại, kiểm tra và hoàn cọc.": "PCRENDER picks them up, checks them and refunds the deposit.",
  "Tiền thuê tính từ ngày nhận hàng. Trả sớm không hoàn lại tiền thuê còn lại.": "Rent counts from the delivery date. Returning early does not refund the remaining rent.",
  "Trả trễ tính thêm theo giá ngày.": "Late returns are charged at the daily rate.",
  "Linh kiện hư hỏng, mất tem hoặc thiếu phụ kiện sẽ bị trừ vào tiền cọc.": "Damaged parts, missing seals or missing accessories are deducted from the deposit.",
  // Quản lý đơn hàng
  "Bắt đầu → Kết thúc": "Start → End",
  "Chiết khấu": "Discount",
  "Chưa có lịch sử": "No history yet",
  "Chưa có đơn hàng nào": "No orders yet",
  "Cloud chưa bật lần nào.": "This Cloud has never been started.",
  "Có gia hạn": "Auto-extend on",
  "Cấu hình": "Configuration",
  "Giá thuê": "Price",
  "Gói": "Plan",
  "Không tìm thấy đơn nào": "No orders found",
  "Loại đơn hàng": "Order type",
  "Lịch sử": "History",
  "Lịch sử sử dụng Cloud": "Cloud usage history",
  "Lịch sử thuê (gia hạn) máy tính": "PC rental (extension) history",
  "Máy": "Machine",
  "Số giờ": "Hours",
  "Số tiền": "Amount",
  "Sử dụng": "Usage",
  "Thêm phần cứng: Thành công": "Hardware add-on: done",
  "Thêm phần cứng: Đang chờ": "Hardware add-on: pending",
  "Thêm phần cứng: Thất bại": "Hardware add-on: failed",
  "Thời gian thực hiện": "Time",
  "Tìm theo tên máy (Image Name)…": "Search by machine name (Image Name)…",
  "Tạo → Hạn dùng": "Created → Expires",
  "Tắt máy lúc": "Stopped at",
  "Tổng tiền": "Total",
  "Tổng đơn": "Total orders",
  "Từ ngày": "From",
  "Đến ngày": "To",
  "Xoá ngày": "Clear dates",
  "Xem lại mọi đơn thuê máy tính, Cloud Gaming - Render và VPS ở một chỗ. Bấm Lịch sử để xem các lần gia hạn hoặc phiên sử dụng.": "All your PC, Cloud Gaming - Render and VPS orders in one place. Press History to see extensions or sessions.",
  "phút": "min",
  "Đang hoạt động": "Active",
  "Đã gia hạn": "Extended",
  "Thử từ khoá khác, đổi khoảng ngày hoặc chọn bộ lọc \"Tất cả\".": "Try another keyword, change the dates or pick \"All\".",
  "Đơn bạn thuê sẽ hiện ở đây.": "Your orders will show up here.",
  "Đơn vị": "Unit",
  "đơn": "orders",
  "Sao chép ID": "Copy ID",
  "Đã xoá": "Deleted",
  // Quản lý đơn hàng (API mới)
  "Tổng chi": "Total spent",
  "Tìm theo tên máy, mã đơn, IP…": "Search by machine name, order ID, IP…",
  "Tìm theo tên Image, mã, IP…": "Search by Image name, ID, IP…",
  "Tìm theo cấu hình, mã VPS, IP…": "Search by plan, VPS ID, IP…",
  "lần": "times",
  "Lịch sử thuê (gia hạn) VPS": "VPS rental (extension) history",
  "Chưa có lịch sử. Đơn thuê trước khi có tính năng này sẽ không có lịch sử.": "No history yet. Orders made before this feature have no history.",
  "Thuê mới": "New rental",
  "Tổng": "Total",
  // Báo khi có hàng
  "Sẽ báo qua email khi có hàng": "We'll email you when it's back in stock",
  "Bạn đã có": "You already have",
  "yêu cầu thuê (tối đa": "rental requests (max",
  "Hãy chờ PCRENDER xử lý hoặc liên hệ hỗ trợ.": "Please wait for PCRENDER to process them or contact support.",
  "Đã tắt báo có hàng": "Back-in-stock alert turned off",
  "Đã đăng ký báo": "Alert on",
  "Báo khi có hàng": "Notify me",
  // Boot máy
  "Tạo máy thành công": "Machine created",
  "Tạo máy thất bại": "Machine creation failed",
  "Máy đã được gỡ khỏi danh sách và tiền thuê đã được hoàn lại vào số dư.": "The machine was removed from the list and the rental fee was refunded to your balance.",
  "Xem máy": "View machine",
  "Bắt đầu tính khi máy tạo xong": "Billing starts once the machine is ready",
  "Đang tải…": "Loading…",
  // Giới thiệu bạn bè
  "Mời bạn bè dùng PCRender và nhận hoa hồng trên mỗi đơn thuê máy, Cloud và VPS của họ.": "Invite friends to PCRender and earn commission on every PC, Cloud and VPS order they make.",
  "Hoa hồng lên đến": "Commission up to",
  "Chính sách hoa hồng": "Commission policy",
  "Bạn chưa có mã giới thiệu": "You don't have a referral code yet",
  "Liên hệ PCRender để được cấp mã giới thiệu và bắt đầu nhận hoa hồng.": "Contact PCRender to get a referral code and start earning commission.",
  "Chia sẻ link hoặc mã": "Share your link or code",
  "Gửi link giới thiệu, hoặc nhờ bạn bè nhập mã khi đăng ký.": "Send your referral link, or ask friends to enter your code when signing up.",
  "Bạn bè thuê dịch vụ": "Friends rent services",
  "Nhận hoa hồng, rút về ngân hàng": "Earn commission, withdraw to your bank",
  "Mã giới thiệu của bạn": "Your referral code",
  "Link giới thiệu": "Referral link",
  "Sao chép link": "Copy link",
  "Sao chép mã": "Copy code",
  "Đã sao chép link giới thiệu": "Referral link copied",
  "Đã sao chép mã giới thiệu": "Referral code copied",
  "Thời hạn nhận": "Earning period",
  "Người được giới thiệu": "Referred users",
  "Số dư hoa hồng": "Commission balance",
  "Tổng hoa hồng đã nhận": "Total commission earned",
  "Rút tiền": "Withdraw",
  "Mã giới thiệu đang tạm dừng, chưa rút được tiền.": "Your referral code is paused, withdrawals are unavailable.",
  "Rút tối thiểu": "Minimum withdrawal",
  "Còn thiếu": "Still needed",
  "Tiền được chuyển về tài khoản ngân hàng sau khi PCRender duyệt yêu cầu.": "Money is sent to your bank account after PCRender approves the request.",
  "Hoạt động giới thiệu": "Referral activity",
  "Lịch sử hoa hồng": "Commission history",
  "Yêu cầu rút tiền": "Withdrawal requests",
  "Đã gửi yêu cầu rút tiền": "Withdrawal request sent",
  "Tạm dừng": "Paused",
  "Chưa có hoa hồng nào": "No commission yet",
  "Khi bạn bè dùng mã của bạn để thuê máy, Cloud hoặc VPS, hoa hồng sẽ hiện ở đây.": "When friends use your code to rent a PC, Cloud or VPS, the commission shows up here.",
  "Dịch vụ": "Service",
  "Mã đơn hàng": "Order ID",
  "Người dùng": "User",
  "Hoa hồng": "Commission",
  "Chưa có ai nhập mã của bạn": "Nobody has used your code yet",
  "Gửi link giới thiệu cho bạn bè. Người đăng ký bằng link hoặc mã của bạn sẽ hiện ở đây.": "Send your referral link to friends. People who sign up with your link or code show up here.",
  "Ngày nhập mã": "Code entered",
  "Hết hạn nhận hoa hồng": "Commission ends",
  "Còn hiệu lực": "Active",
  "Chưa có yêu cầu rút tiền": "No withdrawal requests yet",
  "Bấm Rút tiền ở ví hoa hồng khi số dư đạt tối thiểu 500.000đ.": "Press Withdraw on your commission wallet once the balance reaches 500,000đ.",
  "Ngân hàng": "Bank",
  "Số tài khoản": "Account number",
  "Chủ tài khoản": "Account holder",
  "Đang xử lý": "Processing",
  "Thành công": "Succeeded",
  "Số tiền rút": "Amount to withdraw",
  "Rút hết": "Withdraw all",
  "Tên ngân hàng": "Bank name",
  "Ví dụ: Vietcombank": "e.g. Vietcombank",
  "Nhập số tài khoản": "Enter account number",
  "Viết hoa không dấu, ví dụ NGUYEN VAN A": "Uppercase without accents, e.g. NGUYEN VAN A",
  "Nhớ tài khoản ngân hàng cho lần sau": "Remember this bank account",
  "Gửi yêu cầu rút tiền": "Send withdrawal request",
  "Số tiền được trừ khỏi số dư hoa hồng ngay khi gửi và chuyển về ngân hàng sau khi PCRender duyệt.": "The amount is deducted from your commission balance right away and sent to your bank after PCRender approves.",
  "Tối thiểu": "Minimum",
  // Nạp tiền, biến động số dư
  "Admin cập nhật số dư": "Balance adjusted by admin",
  "Biến động số dư": "Balance history",
  "Bạn có lệnh nạp": "You have a top-up of",
  "Bạn cần nạp thêm": "You need to top up",
  "Bấm lần nữa để huỷ": "Press again to cancel",
  "Chuyển khoản qua mã VietQR. Số dư được cộng tự động khi hệ thống nhận được tiền.": "Pay by VietQR bank transfer. Your balance is credited automatically once the payment arrives.",
  "Chưa có biến động số dư": "No balance changes yet",
  "Chưa có ngân hàng nhận cho mức nạp này": "No receiving bank for this amount",
  "Chưa có ngân hàng nhận cho mức nạp này, vui lòng chọn số tiền khác": "No receiving bank for this amount, please choose another amount",
  "Cách nạp": "How to top up",
  "Ghi đúng số tiền và nội dung để số dư được cộng tự động.": "Keep the exact amount and message so your balance is credited automatically.",
  "Gia hạn Cloud": "Cloud extension",
  "Giữ nguyên số tiền và nội dung chuyển khoản.": "Keep the amount and transfer message unchanged.",
  "Hoàn tiền Cloud": "Cloud refund",
  "Hoàn tiền thuê máy": "PC rental refund",
  "Huỷ nạp": "Cancel top-up",
  "Không tìm thấy giao dịch nào": "No transactions found",
  "Mã QR chuyển khoản": "Transfer QR code",
  "Mã QR hết hạn sau": "QR code expires in",
  "Mọi lần nạp tiền, trừ tiền khi thuê, gia hạn và hoàn tiền. Bấm Xem đơn để mở đơn hàng tương ứng.": "Every top-up, rental charge, extension and refund. Press View order to open the related order.",
  "Mỗi lần nạp tối đa": "Maximum per top-up",
  "Mở mã QR": "Open QR code",
  "Ngân hàng nhận": "Receiving bank",
  "Nhập số tiền để xem ngân hàng nhận": "Enter an amount to see receiving banks",
  "Nhập số tiền, tối thiểu 50.000": "Enter an amount, minimum 50,000",
  "Nạp tiền để bắt đầu thuê máy.": "Top up to start renting.",
  "Nạp tối thiểu": "Top up at least",
  "Quay lại": "Go back",
  "Quay lại để hoàn tất đơn của bạn.": "Go back to finish your order.",
  "Quá 15 phút chưa được cộng tiền? Bấm nút hỗ trợ ở góc phải màn hình để được trợ giúp.": "Not credited after 15 minutes? Use the support button at the bottom right for help.",
  "Quét mã để chuyển khoản": "Scan to transfer",
  "Sau khi nạp": "After top-up",
  "Số dư đã đủ để": "Your balance is now enough to",
  "Số tiền nạp": "Top-up amount",
  "Số tiền phải là bội số của 1.000 VND": "The amount must be a multiple of 1,000 VND",
  "Số tiền đã được điền sẵn, bạn có thể đổi nếu muốn nạp nhiều hơn.": "The amount is pre-filled; change it if you want to top up more.",
  "Thêm phần cứng Cloud": "Cloud hardware add-on",
  "Tiếp tục · Tạo mã QR": "Continue · Create QR code",
  "Tiền ra": "Money out",
  "Tiền vào": "Money in",
  "Tiền đã nạp không được hoàn lại. Hãy nạp đúng số tiền bạn cần dùng để thuê máy.": "Top-ups are non-refundable. Only top up what you need for renting.",
  "Tìm theo nội dung, mã nạp…": "Search by description or top-up code…",
  "Tôi đã chuyển khoản": "I have transferred",
  "Tạo Cloud": "Cloud creation",
  "Tạo lệnh nạp": "Create a top-up",
  "Vui lòng nhập số tiền cần nạp": "Please enter the amount to top up",
  "Xem đơn": "View order",
  "thuê VPS": "rent a VPS",
  "thuê máy tính": "rent a PC",
  "tạo Cloud": "create a Cloud",
  "tiếp tục": "continue",
  "triệu": "M",
  "tối đa": "maximum",
  "Đang tải mã QR…": "Loading QR code…",
  "Đang tải ngân hàng nhận…": "Loading receiving banks…",
  "Đã ghi nhận, số dư sẽ được cộng tự động sau khi hệ thống nhận được tiền": "Noted, your balance will be credited once the payment arrives",
  "Đã huỷ lệnh nạp": "Top-up cancelled",
  "Đóng cửa sổ này không huỷ lệnh nạp. Bạn có thể mở lại mã QR trong Biến động số dư.": "Closing this window doesn't cancel the top-up. You can reopen the QR code from Balance history.",
  "đang chờ thanh toán, còn": "waiting for payment, time left",
  "để": "to",
  "để xem ngân hàng nhận": "to see receiving banks",
  "Nội dung": "Description",
  "Số dư sau": "Balance after",
  "Chờ thanh toán": "Awaiting payment",
  "Nạp trong tháng": "This month",
  "Tổng đã nạp": "Total topped up",
  "Tổng đã chi": "Total spent",
  "Nhập số tiền, chọn ngân hàng": "Enter the amount, pick a bank",
  "Quét mã QR bằng app ngân hàng": "Scan the QR code with your banking app",
  "Bấm \"Tôi đã chuyển khoản\"": "Press \"I have transferred\"",
  "Số dư được cộng tự động sau 1–3 phút.": "Your balance is credited within 1–3 minutes.",
  "Sao chép nội dung": "Copy message",
  // Biến động số dư (thiết kế)
  "Mọi khoản nạp, trừ và hoàn tiền theo thứ tự thời gian, kèm số dư sau mỗi giao dịch.": "Every top-up, charge and refund in time order, with the balance after each transaction.",
  "Nạp tháng này": "Topped up this month",
  "Chi tháng này": "Spent this month",
  "Tìm theo nội dung, mã đơn, số tiền…": "Search by description, order ID, amount…",
  "Thời điểm": "Time",
  "Loại": "Type",
  "Trừ tiền": "Charge",
  "Hoàn tiền": "Refund",
  "Đã hoàn": "Refunded",
  "Nạp tiền chuyển khoản": "Bank transfer top-up",
  "Admin cộng tiền": "Added by admin",
  "Cộng trực tiếp vào số dư": "Added directly to the balance",
  "Mã đơn": "Order ID",
  "Sao chép mã đơn": "Copy order ID",
  "Không đổi": "Unchanged",
  "Hiển thị": "Showing",
  "trong": "of",
  "giao dịch": "transactions",
  // Hướng dẫn sử dụng
  "PCRender Play": "PCRender Play",
  "Máy thuê & thiết bị": "Rented machines & devices",
  "Gia hạn & thanh toán": "Extensions & payment",
  "Game": "Games",
  "Khác": "Other",
  "mở trong tab mới": "opens in a new tab",
  "Không tìm thấy hướng dẫn nào": "No guides found",
  "Chưa có hướng dẫn nào": "No guides yet",
  "Thử từ khoá ngắn hơn, ví dụ \"token\", \"tunnel\" hoặc \"gia hạn\".": "Try a shorter keyword, e.g. \"token\", \"tunnel\" or \"extend\".",
  "Xoá tìm kiếm": "Clear search",
  "Bắt đầu nhanh": "Quick start",
  "Kết quả cho": "Results for",
  "Tìm nhanh hướng dẫn theo chủ đề. Bài hướng dẫn mở ở trang riêng trong tab mới.": "Find guides by topic. Each guide opens on its own page in a new tab.",
  "Bạn cần giúp gì? Ví dụ: token, micro, tunnel, gia hạn…": "How can we help? e.g. token, micro, tunnel, extend…",
  "Chủ đề hướng dẫn": "Guide topics",
  "Chưa tìm thấy câu trả lời?": "Didn't find your answer?",
  "Đội hỗ trợ trực trong thời gian 8h30-12h00 và 13h30-21h00 hàng ngày qua chat.": "Our support team is available daily from 8:30 to 12:00 and 13:30 to 21:00 via chat.",
  "Liên hệ hỗ trợ": "Contact support",
  // tài khoản, đổi mật khẩu
  "Tài khoản và xác minh danh tính": "Account and identity verification",
  "Thông tin đăng nhập, trạng thái xác minh danh tính (eKYC) và bảo mật tài khoản.": "Sign-in details, identity verification (eKYC) status and account security.",
  "Thông tin định danh eKYC": "eKYC identity details",
  "Lấy từ giấy tờ bạn đã xác thực. Một phần thông tin được che để bảo mật.": "Taken from your verified ID. Some details are hidden for security.",
  "Đã xác thực": "Verified",
  "Chưa xác thực": "Not verified",
  "Họ và tên": "Full name",
  "Số CCCD/CMND": "ID number",
  "Ngày sinh": "Date of birth",
  "Giới tính": "Gender",
  "Ngày cấp": "Issue date",
  "Nơi cấp": "Place of issue",
  "Có giá trị đến": "Valid until",
  "Loại giấy tờ": "Document type",
  "Địa chỉ thường trú": "Permanent address",
  "Thông tin bị sai hoặc đã đổi giấy tờ?": "Details wrong or ID changed?",
  "để xác thực lại.": "to verify again.",
  "Thông tin đăng nhập": "Sign-in details",
  "Tên đăng nhập": "Username",
  "Số điện thoại liên hệ": "Contact phone",
  "Đã xác minh": "Verified",
  "Chưa xác minh": "Not verified",
  "Lưu": "Save",
  "Sao chép tên đăng nhập": "Copy username",
  "PC Render gọi số này khi cần xác nhận đơn hàng.": "PC Render calls this number to confirm orders.",
  "Số điện thoại đã xác minh nên không đổi được.": "A verified phone number can't be changed.",
  "Cập nhật lần cuối": "Last updated",
  "Đã lưu số điện thoại liên hệ": "Contact phone saved",
  "Bảo mật": "Security",
  "Mật khẩu": "Password",
  "Đổi bằng liên kết gửi tới email": "Changed via a link sent to your email",
  "Thoát tài khoản trên thiết bị này": "Sign out on this device",
  "Thông tin và xác minh danh tính": "Details and identity verification",
  "Để bảo mật, PC Render gửi liên kết đổi mật khẩu tới email của tài khoản. Liên kết chỉ dùng được một lần.": "For security, PC Render sends a password change link to your account email. The link works only once.",
  "Gửi tới email": "Send to email",
  "Không còn dùng email này?": "No longer use this email?",
  "Gửi liên kết đổi mật khẩu": "Send password change link",
  "Đã gửi liên kết đổi mật khẩu": "Password change link sent",
  "Mở email": "Open the email",
  "và bấm vào liên kết để đặt mật khẩu mới. Không thấy email? Hãy xem mục Thư rác hoặc Quảng cáo.": "and click the link to set a new password. Can't find it? Check your Spam or Promotions folder.",
  "Gửi lại sau": "Resend in",
  "giây": "seconds",
  "Gửi lại email": "Resend email",
  "Xong": "Done",
  "Đã gửi liên kết tới": "Link sent to",
  "Bạn chưa thực hiện xác thực eKYC": "You haven't completed eKYC",
  "Xác thực ngay để bảo mật tài khoản và mở khóa đầy đủ các tính năng trên hệ thống.": "Verify now to secure your account and unlock all features.",
  "Xác thực ngay": "Verify now",
  "Bạn chưa ký hợp đồng thuê máy": "You haven't signed the rental contract",
  "Chỉ còn 1 bước nữa. Ký ngay hợp đồng thuê máy để hoàn tất.": "One step left. Sign the rental contract to finish.",
  "Ký ngay": "Sign now",
  "Bạn chưa xác minh số điện thoại": "You haven't verified your phone",
  "Xác minh ngay để bảo mật tài khoản và mở khóa đầy đủ các tính năng trên hệ thống.": "Verify now to secure your account and unlock all features.",
  "Xác minh ngay": "Verify now",

  // đăng nhập / đăng ký
  "PC Render trang chủ": "PC Render home",
  "Chào mừng bạn tới PC Render": "Welcome to PC Render",
  "Dịch vụ cho thuê máy chủ, server, VPS và PC cấu hình cao có GPU. Chuyển việc nặng sang máy của chúng tôi để máy bạn nhẹ hơn.":
    "Rent servers, VPS and high-end PCs with GPUs. Move heavy work to our machines and keep yours light.",
  "Máy chủ, VPS, PC cấu hình cao có GPU": "Servers, VPS and high-end PCs with GPUs",
  "Điều khiển từ xa qua Remote Desktop, ở đâu cũng dùng được": "Control remotely over Remote Desktop, from anywhere",
  "Thuê tự động 24/7, chỉ vài cú bấm": "Automatic rental 24/7 in a few clicks",
  "Xem video hướng dẫn sử dụng": "Watch the user guide video",
  "Chào mừng bạn quay lại PC Render.": "Welcome back to PC Render.",
  "Tên tài khoản": "Username",
  "Nhập tên tài khoản": "Enter your username",
  "Nhập mật khẩu": "Enter your password",
  "Quên mật khẩu?": "Forgot password?",
  "Bạn chưa có tài khoản?": "Don't have an account?",
  "Đăng ký ngay": "Sign up now",
  "Đăng ký": "Sign up",
  "Nhập mã OTP": "Enter OTP code",
  "Mã 6 số vừa được gửi tới email đăng ký của tài khoản.": "A 6-digit code was just sent to the account's email.",
  "Mã OTP": "OTP code",
  "Mã có hiệu lực trong 2 phút. Không thấy email? Hãy xem mục Thư rác hoặc Quảng cáo.":
    "The code is valid for 2 minutes. No email? Check your Spam or Promotions folder.",
  "Xác nhận và đăng nhập": "Confirm and log in",
  "Gửi lại mã sau": "Resend code in",
  "Gửi lại mã": "Resend code",
  "Đã gửi mã OTP mới về email": "A new OTP code was sent to your email",
  "Tạo tài khoản": "Create account",
  "Điền thông tin bên dưới để tạo tài khoản PC Render.": "Fill in the details below to create your PC Render account.",
  "3–20 ký tự": "3–20 characters",
  "Nguyễn Văn A": "John Smith",
  Email: "Email",
  "Nhập lại mật khẩu": "Confirm password",
  "Mã giới thiệu": "Referral code",
  "Bỏ qua nếu không có": "Leave blank if you have none",
  "không bắt buộc": "optional",
  "Tôi đồng ý với": "I agree to the",
  "Điều khoản dịch vụ": "Terms of Service",
  "của PC Render": "of PC Render",
  "Bạn đã có tài khoản?": "Already have an account?",
  "Xác minh tài khoản": "Verify your account",
  "Chúng tôi đã gửi liên kết xác minh tới": "We sent a verification link to",
  "Bạn hãy kiểm tra email để xác minh tài khoản rồi đăng nhập.": "Check your email to verify your account, then log in.",
  "Đến email": "Open email",
  "Tên tài khoản không được để trống": "Username is required",
  "Tên tài khoản không dưới 3 ký tự": "Username must be at least 3 characters",
  "Tên tài khoản không quá 20 ký tự": "Username must be at most 20 characters",
  "Họ tên không được để trống": "Full name is required",
  "Họ tên không dưới 5 ký tự": "Full name must be at least 5 characters",
  "Họ tên không quá 50 ký tự": "Full name must be at most 50 characters",
  "Email không được để trống": "Email is required",
  "Địa chỉ email không hợp lệ": "Invalid email address",
  "Email không dưới 3 ký tự": "Email is too short",
  "Email không quá 50 ký tự": "Email must be at most 50 characters",
  "Số điện thoại không được để trống": "Phone number is required",
  "Số điện thoại không hợp lệ": "Invalid phone number",
  "Mật khẩu không được để trống": "Password is required",
  "Nhập lại mật khẩu không được để trống": "Please confirm your password",
  "Nhập lại mật khẩu không khớp": "Passwords do not match",
  "Yêu cầu xác nhận": "Please accept the terms",
  // trang chủ (/home)
  "Trang quản lý": "Dashboard",
  "Cho thuê máy tính từ xa": "Remote PC rental",
  "Cho thuê máy tính vật lý sử dụng CPU": "Rent physical computers with",
  "dual Xeon lên tới 44 core 88 luồng": "dual Xeon CPUs up to 44 cores / 88 threads",
  "kết hợp": "paired with a",
  "VGA 3060 12GB": "3060 12GB GPU",
  "vô cùng mạnh mẽ chỉ từ": "for serious power, from just",
  "15.000 vnđ": "15,000 VND",
  "sử dụng ngay.": "ready to use right away.",
  "Cho thuê PC cấu hình cao, thuê server GPU và thuê VPS GPU cho render, đồ họa, AI, treo giả lập và Cloud Gaming.": "High-end PC rental, GPU server and GPU VPS rental for rendering, graphics, AI, emulators and Cloud Gaming.",
  "Website cho thuê tự động 24/7.": "Fully automated rental, 24/7.",
  "Đăng ký, đăng nhập để sử dụng tính năng!": "Sign up or log in to get started!",
  "Thuê máy ngay": "Rent a PC now",
  "Xem bảng giá": "See pricing",
  "44 core · 88 luồng": "44 cores · 88 threads",
  "tới RTX 4090": "up to RTX 4090",
  "Tự động 24/7": "Automated 24/7",
  "tạo máy ngay sau khi thanh toán": "machine ready right after payment",
  "PC Render trong số liệu": "PC Render in numbers",
  "cấu hình máy vật lý": "physical PC configurations",
  "VND/giờ, giá thấp nhất": "VND/hour, lowest price",
  "tự động tạo máy": "automatic provisioning",
  "Giờ · Ngày · Tháng": "Hour · Day · Month",
  "thanh toán linh hoạt": "flexible billing",
  "Dịch Vụ Tiêu Biểu Tại PcRender": "Featured Services at PcRender",
  "Dịch vụ Cloud VPS, hiệu suất cao, đồng hành cùng sự phát triển của bạn.": "High-performance Cloud VPS services that grow with you.",
  "PC vật lý chạy trên hệ điều hành Windows. Hỗ trợ VGA 4080, 4090…": "Physical PCs running Windows. Supports RTX 4080, 4090…",
  "Máy tính render video, thuê máy render Blender, thuê PC chạy Solidworks theo giờ.": "Video rendering PCs, Blender render machines and Solidworks PCs rented by the hour.",
  "Xem cấu hình Render": "See Render configurations",
  "Dịch vụ Thuê Máy Chủ Vật Lý": "Physical Server Rental",
  "Dịch vụ Thuê Server tại Pc Render Cloud có Phần cứng máy chủ mạnh mẽ, tốc độ mạng nhanh, hiệu năng cao, hỗ trợ 24/7.": "Server rental at Pc Render Cloud: powerful server hardware, fast network, high performance and 24/7 support.",
  "Thuê server GPU chạy render, AI và đồ họa, trả theo giờ, ngày hoặc tháng.": "Rent GPU servers for rendering, AI and graphics, paid by the hour, day or month.",
  "Xem tất cả máy chủ": "See all servers",
  "PC GIẢ LẬP": "EMULATOR PC",
  "PC vật lý chạy trên hệ điều hành Windows. Hỗ trợ CPU Xeon 2680V4, 2696V4… cùng VGA 1080, 1080Ti, 3060…": "Physical PCs running Windows. Xeon 2680V4, 2696V4… CPUs with GTX 1080, 1080Ti, RTX 3060… GPUs.",
  "Thuê PC treo giả lập, treo game giả lập LDPlayer nhiều cửa sổ, chạy MMO 24/7.": "Rent PCs for emulators: run many LDPlayer windows and MMO tasks 24/7.",
  "Xem cấu hình Giả lập": "See Emulator configurations",
  "Bảng Giá Dịch Vụ Thuê Máy Chủ Vật Lý": "Physical Server Rental Pricing",
  "đơn vị VNĐ": "prices in VND",
  "Đơn vị VNĐ": "Prices in VND",
  "Lọc theo nhu cầu": "Filter by use case",
  "Tên Server": "Server",
  "Giá theo giờ": "Per hour",
  "Giá theo ngày": "Per day",
  "Giá theo tháng": "Per month",
  "Thuê Ngay": "Rent now",
  "Thu gọn": "Show less",
  "Xem thêm": "Show",
  "Giá theo ngày = 24 giờ, giá theo tháng = 720 giờ. Giá cập nhật tự động theo trang Thuê máy tính.": "Daily price = 24 hours, monthly price = 720 hours. Prices update automatically from the Rent a PC page.",
  "từ": "from",
  "VND/giờ": "VND/hour",
  "Thuê Máy Theo Nhu Cầu": "Rent by Use Case",
  "Chọn đúng loại máy cho công việc của bạn, máy tạo tự động ngay sau khi thanh toán.": "Pick the right machine for your work; it is created automatically right after payment.",
  "Render video, Blender, Solidworks": "Video rendering, Blender, Solidworks",
  "Máy tính render video với RTX 3090, 4090. Thuê máy render Blender, thuê PC chạy Solidworks, 3ds Max theo giờ, không cần đầu tư phần cứng.": "Video rendering PCs with RTX 3090, 4090. Rent Blender render machines and PCs for Solidworks or 3ds Max by the hour, with no hardware investment.",
  "Treo giả lập, MMO": "Emulators, MMO",
  "Thuê PC treo giả lập dual Xeon RAM lớn, treo game giả lập LDPlayer nhiều cửa sổ cùng lúc, chạy 24/7 không lo mất điện, mất mạng.": "Rent dual Xeon PCs with large RAM for emulators, run many LDPlayer windows at once, 24/7 with no worries about power or network outages.",
  "Thuê máy chơi Cloud Gaming cấu hình cao, chơi game nặng trên laptop yếu hoặc điện thoại qua PCRender Play, mua gói giờ chơi dùng dần.": "Rent high-end Cloud Gaming machines, play demanding games on a weak laptop or phone through PCRender Play, and buy play-hour packages to use over time.",
  "Server GPU, VPS GPU": "GPU servers, GPU VPS",
  "Thuê server GPU vật lý cho AI, render, đồ họa. Thuê VPS GPU giá rẻ theo tháng cho web, bot và chạy giả lập nhẹ.": "Rent physical GPU servers for AI, rendering and graphics. Rent affordable monthly GPU VPS for websites, bots and light emulators.",
  "Cloud VPS Của PC Render Có Gì Tốt?": "Why Choose PC Render Cloud VPS?",
  "Hệ thống cho thuê tự động 24/7, thanh toán linh hoạt theo giờ, ngày, tháng.": "Automated rental 24/7, with flexible hourly, daily or monthly billing.",
  "PHẦN CỨNG MẠNH MẼ": "POWERFUL HARDWARE",
  "Khi sử dụng dịch vụ tại PCRender, bạn có thể hoàn toàn yên tâm. Sử dụng CPU dual Xeon mới nhất, kết hợp cùng VGA 1080, 1080Ti, 3060… vô cùng mạnh mẽ.": "With PCRender you can rest easy: the latest dual Xeon CPUs paired with powerful GTX 1080, 1080Ti, RTX 3060… GPUs.",
  "NHIỀU LỰA CHỌN CẤU HÌNH": "MANY CONFIGURATIONS",
  "PCRender cung cấp nhiều cấu hình tự chọn, từ VGA 1050Ti tới VGA 3060, 4090… vô cùng mạnh mẽ.": "PCRender offers many configurations to choose from, from GTX 1050Ti up to the powerful RTX 3060, 4090…",
  "THÔNG TIN MINH BẠCH, CHÍNH SÁCH RÕ RÀNG": "TRANSPARENT INFORMATION, CLEAR POLICIES",
  "Tất cả các thông tin liên quan đến": "All information about the",
  "điều khoản": "terms",
  "và chính sách của Pc Render Cloud có nội dung thể hiện đầy đủ, chi tiết và được công khai. Khách hàng có thể an tâm tuyệt đối.": "and policies of Pc Render Cloud is complete, detailed and public, so customers can feel fully at ease.",
  "THANH TOÁN LINH HOẠT": "FLEXIBLE PAYMENT",
  "Bạn có thể thanh toán theo giờ, ngày, tháng, năm, tùy vào nhu cầu sử dụng của bạn, hệ thống hoạt động 24/7 nên bạn có thể thuê máy bất kỳ thời gian nào.": "Pay by the hour, day, month or year as you need. The system runs 24/7, so you can rent a machine at any time.",
  "Hệ Điều Hành Hỗ Trợ": "Supported Operating Systems",
  "Chúng tôi hỗ trợ đầy đủ loại hệ điều hành Windows và Linux cho dịch vụ Cloud VPS.": "We fully support Windows and Linux operating systems for our Cloud VPS services.",
  "Cài đặt nhanh chóng, thuận tiện chỉ với một click chuột.": "Fast, convenient installation with a single click.",
  "Thuê máy, Cloud": "Rent, Cloud",
  "Linux · Thuê VPS": "Linux · Rent a VPS",
  "Câu Hỏi Thường Gặp": "Frequently Asked Questions",
  "Cho thuê máy tính từ xa là gì?": "What is remote PC rental?",
  "Bạn thuê một máy tính vật lý cấu hình cao đặt tại PCRender và điều khiển từ xa qua Remote Desktop hoặc PCRender Play. Máy được tạo tự động ngay sau khi thanh toán, dùng theo giờ, ngày hoặc tháng.": "You rent a high-end physical computer hosted at PCRender and control it remotely through Remote Desktop or PCRender Play. The machine is created automatically right after payment and can be used by the hour, day or month.",
  "Thuê máy render Blender, Solidworks nên chọn cấu hình nào?": "Which configuration should I rent for Blender or Solidworks?",
  "Render video và Blender nên chọn máy có RTX 3090 hoặc 4090 VRAM 24GB. Thuê PC chạy Solidworks nên ưu tiên CPU xung cao như i7, i9 và RAM từ 64GB. Xem các cấu hình Render trong bảng giá phía trên.": "For video rendering and Blender, choose a machine with an RTX 3090 or 4090 with 24GB VRAM. For Solidworks, prefer high-clock CPUs such as i7 or i9 and 64GB of RAM or more. See the Render configurations in the pricing table above.",
  "Render video và Blender nên chọn máy có RTX 3090 hoặc 4090 VRAM 24GB. Thuê PC chạy Solidworks nên ưu tiên CPU xung cao như i7, i9 và RAM từ 64GB.": "For video rendering and Blender, choose a machine with an RTX 3090 or 4090 with 24GB VRAM. For Solidworks, prefer high-clock CPUs such as i7 or i9 and 64GB of RAM or more.",
  "Có thuê PC treo giả lập LDPlayer theo giờ được không?": "Can I rent a PC for LDPlayer emulators by the hour?",
  "Được. Các cấu hình Giả lập dùng CPU dual Xeon và RAM 128GB đến 256GB, treo game giả lập LDPlayer nhiều cửa sổ, thuê từ 1 giờ và gia hạn bất cứ lúc nào.": "Yes. Emulator configurations use dual Xeon CPUs with 128GB to 256GB of RAM to run many LDPlayer windows. Rent from 1 hour and extend at any time.",
  "Thuê server GPU và thuê VPS GPU khác nhau thế nào?": "What is the difference between a GPU server and a GPU VPS?",
  "Thuê server GPU là thuê nguyên một máy chủ vật lý, toàn bộ CPU và card đồ họa dành riêng cho bạn. Thuê VPS GPU là máy ảo chia sẻ phần cứng, giá rẻ hơn, phù hợp tác vụ nhẹ và chạy lâu dài theo tháng.": "A GPU server is a whole physical server, with all of its CPU and graphics card dedicated to you. A GPU VPS is a virtual machine on shared hardware: cheaper, suited to light workloads and long-running monthly use.",
  "Thuê máy chơi Cloud Gaming tính tiền thế nào?": "How is Cloud Gaming billed?",
  "Bạn mua gói gồm số giờ chơi và hạn sử dụng. Giờ chỉ bị trừ khi máy đang bật, mỗi lần bật có giới hạn session và máy tự tắt khi hết session.": "You buy a package with a number of play hours and a validity period. Hours are only deducted while the machine is on; each start has a session limit and the machine turns off when the session ends.",
  "Cùng nhau, Trực tuyến.": "Together, Online.",
  "Chúng tôi ở đây giúp các bạn có thể làm việc online một cách hiệu quả nhất.": "We are here to help you work online as effectively as possible.",
  "Số 6 Tự Do 1, Phường Phú Thọ, TP Hồ Chí Minh": "6 Tu Do 1 Street, Phu Tho Ward, Ho Chi Minh City",
  "Thông tin": "Information",
  "Giới Thiệu": "About us",
  "Liên Hệ": "Contact",
  "Điều Khoản": "Terms",
  "Theo Dõi Chúng Tôi": "Follow Us",
  "(VNĐ)": "(VND)",
};

export default en;
